import React, { Component } from "react";
import { Row, Col, Container } from "react-bootstrap";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { isBrowser } from "react-device-detect";
import CreateAdmissionFormPage from "../components/admissionForms/CreateAdmissionFormPage";

const GET_ENQUIRY_FORM_FIELDS = gql`
  query ($form_id: Int!, $institute_id: Int) {
    getEnquiryFormFields(form_id: $form_id, institute_id: $institute_id) {
      id
      field_name
      field_type_id
    }
  }
`;

const FETCH_GLOBALS = gql`
  query ($institution_id: Int!) {
    globals(institution_id: $institution_id) {
      globalBranches {
        id
        branch_name
      }
    }
  }
`;

class CreateAdmissionForms extends Component {
  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      this.setState({ toggled: "wrapper" });
      Cookies.set("toggle", "wrapper");
    }
  };

  render() {
    if (Cookies.get("token") == undefined) {
      this.props.history.push("/login");
      return null;
    }

    const getFormFields = this.props.getEnquiryFormFields;
    const loading1 = getFormFields.loading;
    const error1 = getFormFields.error;

    const globals = this.props.globals;
    const loading2 = globals.loading;
    const error2 = globals.error;

    if (error1 !== undefined) {
      alert("Server Error. " + error1.message);
      return null;
    }

    if (error2 !== undefined) {
      alert("Server Error. " + error2.message);
      return null;
    }

    return (
      <div className={Cookies.get("toggle") || "wrapper"}>
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />
        </div>
        <div className="main-wrapper">
          <div
            id="sidebar"
            className={
              isBrowser === true
                ? "sidebar-menu d-none d-xl-block d-lg-block"
                : "sidebar-menu d-block d-xl-none d-lg-none"
            }
          >
            <SideNavbar onClick={() => this.menuToggler()} />
          </div>
          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper pt-0" style={{ minHeight: "50vh" }}>
            <Container fluid>
              {loading1 || loading2 ? (
                <Container>
                  <Row className="my-2">
                    <Col>
                      <div className="spinner-border text-primary text-center loading-img-center"></div>
                    </Col>
                  </Row>
                </Container>
              ) : (
                <>
                  {(() => {
                    let globalsData = globals.globals;

                    if (
                      Cookies.get("userlevel") != "1" &&
                      Cookies.get("userlevel") != "2"
                    ) {
                      let authorizedIds = [];
                      try {
                        const cookie = Cookies.get("branch_id");
                        const parsed = cookie ? JSON.parse(cookie) : [];
                        authorizedIds = Array.isArray(parsed) ? parsed : [parsed];
                      } catch (e) {
                        try {
                          const cookie = Cookies.get("branch_id");
                          authorizedIds = cookie ? cookie.split(",").map(id => id.trim()) : [];
                        } catch (err) { console.error(err); }
                      }
                      authorizedIds = authorizedIds.map(String);

                      let globalBranches = [];
                      globalsData.globalBranches.map((item) => {
                        if (authorizedIds.includes("all") || authorizedIds.includes(String(item.id))) {
                          globalBranches.push(item);
                        }
                      });
                      globalsData.globalBranches = globalBranches;
                    }

                    // Extract state data passed via React Router history
                    const stateData = this.props.location.state || {};

                    return (
                      <CreateAdmissionFormPage
                        globals={globalsData}
                        getEnquiryFormFields={getFormFields}
                        stateData={stateData}
                      />
                    );
                  })()}
                </>
              )}
            </Container>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

export default withRouter(
  compose(
    graphql(GET_ENQUIRY_FORM_FIELDS, {
      options: () => ({
        variables: { form_id: 0, institute_id: parseInt(Cookies.get("institutionid")) },
      }),
      name: "getEnquiryFormFields",
    }),
    graphql(FETCH_GLOBALS, {
      options: () => ({
        variables: {
          institution_id: parseInt(Cookies.get("institutionid")),
        },
      }),
      name: "globals",
    }),
  )(CreateAdmissionForms),
);
